"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Menu = function () { return (react_1.default.createElement("svg", { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M3 12h18M3 6h18M3 18h18", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round" }))); };
exports.default = Menu;
//# sourceMappingURL=Menu.js.map